// extracted by mini-css-extract-plugin
export default {"bannerVars":"Banner_bannerVars__TLDUf","banner":"Banner_banner__pDz1a","content":"Banner_content__F8gR3","imgBanner":"Banner_imgBanner__e+jYH"};